module.exports = ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 71
// module chunks = 0